const siteUrl = process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk';

export const seoConfig = {
  home: {
    title: "Fixinn - Professional Phone Repair, Laptop Repair & Tech Support Services",
    description: "Expert repair and support services for phones, laptops, computers, watches, plus tennis coaching and computer training. Professional technicians, quick turnaround, genuine parts guaranteed.",
    keywords: "phone repair, laptop repair, smartphone repair, computer support, tech support, watch repair, tennis coaching, computer coaching, fixinn, device repair services",
    canonical: `${siteUrl}/`,
    ogTitle: "Fixinn - Your Trusted Tech Repair & Support Experts",
    ogDescription: "Get professional repair services for phones, laptops, computers, and watches. Plus tech support, computer coaching, and tennis stringing services.",
    ogImage: `${siteUrl}/images/fixinn-services-hero.jpg`,
    twitterTitle: "Fixinn - Professional Tech Repair & Support Services",
    twitterDescription: "Expert repair services for phones, laptops, computers, watches. Tech support, computer coaching & tennis services available."
  },

  about: {
    title: "About Fixinn - Professional Tech Repair & Support Experts | Our Story",
    description: "Learn about Fixinn's mission to provide exceptional phone repair, laptop repair, tech support, and coaching services. Meet our certified technicians and discover why customers trust us.",
    keywords: "about fixinn, tech repair company, certified technicians, professional repair services, company history, mission, values, phone repair experts",
    canonical: `${siteUrl}/about`,
    ogTitle: "About Fixinn - Your Tech Repair & Support Professionals",
    ogDescription: "Discover Fixinn's commitment to excellence in tech repair and support services. Professional, reliable, and customer-focused solutions.",
    ogImage: `${siteUrl}/images/fixinn-team.jpg`
  },

  contact: {
    title: "Contact Fixinn - Get Your Device Repair Quote Today | Call Now",
    description: "Contact Fixinn for professional phone repair, laptop repair, tech support, and coaching services. Get instant quotes, schedule appointments, and connect with certified technicians.",
    keywords: "contact fixinn, device repair quote, schedule appointment, customer service, phone number, email, location, service areas, tech support",
    canonical: `${siteUrl}/contact`,
    ogTitle: "Contact Fixinn - Schedule Your Device Repair Service",
    ogDescription: "Ready to fix your device issues? Contact Fixinn today for professional repair services. Quick quotes and flexible scheduling available.",
    ogImage: `${siteUrl}/images/fixinn-contact.jpg`
  },

  services: {
    title: "Tech Repair Services - Phone, Laptop, Computer & Watch Repair | FixiNN",
    description: "Comprehensive tech repair services including phone repair, laptop repair, computer support, watch repair, tennis coaching, and computer training. Professional technicians, quality guaranteed.",
    keywords: "tech repair services, phone repair, laptop repair, smartphone repair, computer support, watch repair, tennis coaching, computer training, device repair",
    canonical: `${siteUrl}/services`,
    ogTitle: "Professional Tech Repair Services by Fixinn",
    ogDescription: "Complete range of tech repair services from certified professionals. Phone, laptop, computer, watch repair and more. Quality work guaranteed.",
    ogImage: `${siteUrl}/images/fixinn-all-services.jpg`
  }
};

// Service-specific SEO configurations based on actual services
export const serviceDetailSEO = {
  "phone-repair-service": {
    title: "Professional Phone Repair Services - Screen, Battery & More | FixiNN",
    description: "Expert smartphone repair services including screen replacement, battery replacement, charging port repairs, water damage repair, and software fixes. All major brands supported.",
    keywords: "phone repair, smartphone repair, screen replacement, battery replacement, charging port repair, water damage repair, iPhone repair, Android repair, mobile phone repair",
    canonical: `${siteUrl}/services/phone-repair-service`,
    ogTitle: "Professional Phone Repair Services - FixiNN",
    ogDescription: "Fast, reliable phone repair services. Screen replacement, battery issues, water damage, and more. Certified technicians with genuine parts.",
    ogImage: `${siteUrl}/images/services/phone-repair-service.jpg`
  },

  "laptop-repair-services": {
    title: "Expert Laptop Repair Services - Hardware & Software Solutions | FixiNN",
    description: "Professional laptop repair services including screen replacement, battery replacement, keyboard repairs, hard drive upgrades, and software troubleshooting for all major brands.",
    keywords: "laptop repair, laptop screen replacement, laptop battery replacement, keyboard repair, hard drive upgrade, SSD upgrade, laptop software repair, computer repair",
    canonical: `${siteUrl}/services/laptop-repair-services`,
    ogTitle: "Professional Laptop Repair Services - FixiNN",
    ogDescription: "Complete laptop repair solutions from hardware fixes to software troubleshooting. Quick turnaround, genuine parts, expert technicians.",
    ogImage: `${siteUrl}/images/services/laptop-repair-services.jpg`
  },

  "home-tech-support": {
    title: "Home Tech Support Services - Wi-Fi, Smart Devices & More | FixiNN",
    description: "Comprehensive home tech support including Wi-Fi setup, smart device configuration, computer troubleshooting, printer setup, and data backup services.",
    keywords: "home tech support, Wi-Fi setup, smart device setup, computer troubleshooting, printer setup, data backup, network setup, tech help",
    canonical: `${siteUrl}/services/home-tech-support`,
    ogTitle: "Home Tech Support Services - FixiNN",
    ogDescription: "On-site tech support for your home. Wi-Fi setup, smart devices, computer help, and more. Experienced technicians at your service.",
    ogImage: `${siteUrl}/images/services/home-tech-support.jpg`
  },

  "computer-coaching-service": {
    title: "Computer Coaching & Training Services - Learn Digital Skills | FixiNN",
    description: "Personalized computer coaching sessions covering basic skills, office applications, email setup, cybersecurity awareness, and customized learning plans for all skill levels.",
    keywords: "computer coaching, computer training, digital skills training, office applications training, computer lessons, email training, cybersecurity training, computer education",
    canonical: `${siteUrl}/services/computer-coaching-service`,
    ogTitle: "Computer Coaching & Training Services - FixiNN",
    ogDescription: "Learn computer skills with personalized coaching. From basics to advanced applications. Flexible scheduling and supportive learning environment.",
    ogImage: `${siteUrl}/images/services/computer-coaching-service.jpg`
  },

  "tennis-coaching-service": {
    title: "Tennis Stringing & Coaching Services - Professional Training | FixiNN",
    description: "Professional tennis services including racquet stringing, grip replacement, private coaching, group clinics, and match analysis for players of all levels.",
    keywords: "tennis coaching, tennis stringing, racquet stringing, tennis lessons, private tennis coaching, group tennis clinics, tennis training, tennis instruction",
    canonical: `${siteUrl}/services/tennis-coaching-service`,
    ogTitle: "Tennis Stringing & Coaching Services - FixiNN",
    ogDescription: "Elevate your tennis game with professional stringing services and personalized coaching. All skill levels welcome.",
    ogImage: `${siteUrl}/images/services/tennis-coaching-service.jpg`
  },

  "watch-repair-service": {
    title: "Professional Watch Repair & Servicing - Battery, Movement & More | FixiNN",
    description: "Expert watch repair services including battery replacement, strap adjustments, movement overhaul, crystal replacement, and water resistance testing for all watch brands.",
    keywords: "watch repair, watch battery replacement, watch servicing, watch movement repair, watch strap adjustment, crystal replacement, watch maintenance",
    canonical: `${siteUrl}/services/watch-repair-service`,
    ogTitle: "Professional Watch Repair & Servicing - FixiNN",
    ogDescription: "Restore your timepiece to perfection. Expert watch repair, battery replacement, servicing, and maintenance. Experienced watchmakers.",
    ogImage: `${siteUrl}/images/services/watch-repair-service.jpg`
  }
};